module.exports = __webpack_public_path__ + "img/role_3_name.9d7c88bd.png";